import { Action, createReducer, on } from '@ngrx/store';

import { LoadingTypes } from 'src/app/shared/models/enums/loading.enum';
import { JobItem } from 'src/app/recruiting/candidates/live-nurses-new/components/jobs/models/dto/job-item';
import { SubmittalStatusEnum } from 'src/app/accountmanagers/submittals/model/enums/submittal-status.enum';
import * as actions from 'src/app/recruiting/candidates/live-nurses-new/store/live-nurses.actions';

export interface SubmittalJobsState {
    submittalJobs: JobItem[];
    loading: LoadingTypes;
    isBusy?: boolean;
}

const initialState: SubmittalJobsState = {
    submittalJobs: [],
    loading: LoadingTypes.INIT
};

export function liveNursesSubmittalJobReducer(reducerState: SubmittalJobsState, reducerAction: Action) {
    return createReducer(
        initialState,
        on(actions.deleteJob, (state, action) => ({
            ...state,
            loading: LoadingTypes.LOADING
        })),

        on(actions.deleteJobSuccess, (state: SubmittalJobsState, action) => {
            return {
                ...state,
                submittalJobs: state.submittalJobs.filter(
                    (sj) => action.jobId !== sj.jobId && action.submittalId !== sj.submittalId
                ),
                loading: LoadingTypes.LOADED
            };
        }),

        on(actions.deleteJobFail, (state, action) => ({
            ...state,
            loading: LoadingTypes.LOADED
        })),

        on(actions.addJob, (state, action) => ({
            ...state,
            loading: LoadingTypes.LOADING
        })),

        on(actions.modifyingJobs, (state, action) => ({
            ...state,
            loading: LoadingTypes.LOADING, // (action.isBusy) ? LoadingTypes.LOADING : LoadingTypes.LOADED,
            isBusy: action.isBusy
        })),

        on(actions.addJobFail, (state, action) => ({
            ...state,
            loading: LoadingTypes.LOADED
        })),

        on(actions.addJobSuccess, (state: SubmittalJobsState, action) => {
            const newJobsOnly = action.jobs.filter(
                (f) =>
                    state.submittalJobs.findIndex((fi) => fi.jobId === f.jobId && fi.submittalId === f.submittalId) ===
                    -1
            );
            return {
                ...state,
                //submittalJobs: state.submittalJobs.filter(sj => !action.jobs.map(aj => aj.jobId).includes(sj.jobId)).concat(action.jobs),
                submittalJobs: state.submittalJobs.concat(newJobsOnly),
                loading: LoadingTypes.LOADED
            };
        }),
        on(actions.resetStoreJobs, (state: SubmittalJobsState, action) => {
            return {
                ...state,
                submittalJobs: [],
                loading: LoadingTypes.LOADED
            };
        }),
        on(actions.setSubmittalJobs, (state: SubmittalJobsState, action): SubmittalJobsState => {
            return {
                ...state,
                loading: LoadingTypes.LOADED,
                submittalJobs: action.submittalJobs
            };
        }),
        on(actions.setSubmittalAsVerballyAccepted, (state: SubmittalJobsState): SubmittalJobsState => {
            return {
                ...state,
                loading: LoadingTypes.LOADING
            };
        }),
        on(actions.setSubmittalAsVerballyAcceptedSuccess, (state: SubmittalJobsState, action): SubmittalJobsState => {
            const submittalJobs = JSON.parse(JSON.stringify(state.submittalJobs)) as JobItem[];
            return {
                ...state,
                loading: LoadingTypes.LOADED,
                submittalJobs: submittalJobs.map((job: JobItem) => {
                    if (job.offerId === action.offerId) {
                        job.offerVerballyAccepted = true;
                        job.submittalStatusId = SubmittalStatusEnum.OfferVerballyAccepted;
                        job.submittalStatusName = 'Offer Verbally Accepted';
                        job.submittalSubStatusId = null;
                        job.submittalSubStatusName = null;
                    }
                    return job;
                })
            };
        })
    )(reducerState, reducerAction);
}
